const styles = {
  card: {
    minHeight: '200px !important',
    width: '100% !important',
    boxShadow: '0 2px 6px 0 rgba(0,0,0,0.05) !important',
    borderRight: '1px solid #f7f7f7 !important',
  },
  header: {
    padding: '16px !important',
    boxShadow: '0 2px 6px 0 rgba(0,0,0,0.05)',
    color: '#440C7F !important',
    fontWeight: 'bold',
  },
  description: {
    padding: '12px !important',
    color: '#797979 !important',
    fontSize: '14px !important',
    lineHeight: '28px !important',
    maxHeight: '10em',
    minHeight: '10em',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  icon: {
    height: '27px !important',
    width: '27px !important',
    marginRight: '8px !important',
  },
  noPadding: {
    padding: '0 !important',
  },
  modalButton: {
    width: '50%',
    margin: '0 auto',
  },
};

export default styles;
